import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function PrivacyPage() {
  return <div className="min-h-screen w-full bg-[#FAFAF7] text-[#3D3D3D] font-sans selection:bg-[#1B6B3A] selection:text-white" data-id="element-224">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-12 md:py-20 lg:py-28" data-id="element-225">
        <Link to="/" className="inline-flex items-center gap-2 text-[#1B6B3A] hover:text-[#165930] transition-colors mb-10 lg:mb-14 text-sm lg:text-base font-medium" data-id="element-226">
          <ArrowLeft className="w-4 h-4" data-id="element-227" />
          Back to Closing Number Lock
        </Link>

        <h1 className="text-3xl lg:text-5xl font-serif font-bold text-[#1A1A1A] mb-4 lg:mb-6" data-id="element-228">
          Privacy Policy
        </h1>
        <p className="text-sm lg:text-base text-[#6B6B6B] mb-12 lg:mb-16" data-id="element-229">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })}
        </p>

        <div className="space-y-10 lg:space-y-14 text-base lg:text-lg leading-relaxed lg:leading-loose" data-id="element-230">
          <section data-id="element-231">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-232">
              1. Introduction
            </h2>
            <p data-id="element-233">
              Closing Number Lock ("we," "us," or "our") respects your privacy.
              This Privacy Policy explains how we collect, use, and protect your
              personal information when you purchase and use our digital
              product.
            </p>
          </section>

          <section data-id="element-234">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-235">
              2. Information We Collect
            </h2>
            <p className="mb-4" data-id="element-236">
              When you purchase the Product, we may collect:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[#3D3D3D]" data-id="element-237">
              <li data-id="element-238">
                <strong data-id="element-239">Contact information</strong> — Your name and email
                address for product delivery and communication.
              </li>
              <li data-id="element-240">
                <strong data-id="element-241">Payment information</strong> — Payment details are
                processed securely by our third-party payment processor. We do
                not store your credit card or bank information.
              </li>
              <li data-id="element-242">
                <strong data-id="element-243">Usage data</strong> — Basic analytics about how you
                interact with our website (pages visited, time on site).
              </li>
            </ul>
          </section>

          <section data-id="element-244">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-245">
              3. How We Use Your Information
            </h2>
            <p className="mb-4" data-id="element-246">We use your information to:</p>
            <ul className="list-disc pl-6 space-y-2 text-[#3D3D3D]" data-id="element-247">
              <li data-id="element-248">Deliver the Product to you after purchase</li>
              <li data-id="element-249">Send purchase confirmations and product updates</li>
              <li data-id="element-250">Respond to your questions or support requests</li>
              <li data-id="element-251">Improve our website and product offerings</li>
            </ul>
          </section>

          <section data-id="element-252">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-253">
              4. Email Communications
            </h2>
            <p data-id="element-254">
              After purchase, you may receive emails related to your order
              (delivery, follow-up tips). You can unsubscribe from
              non-transactional emails at any time by clicking the unsubscribe
              link at the bottom of any email.
            </p>
          </section>

          <section data-id="element-255">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-256">
              5. Third-Party Services
            </h2>
            <p className="mb-4" data-id="element-257">
              We use trusted third-party services to operate our business:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[#3D3D3D]" data-id="element-258">
              <li data-id="element-259">
                <strong data-id="element-260">Payment processing</strong> — To securely handle
                transactions.
              </li>
              <li data-id="element-261">
                <strong data-id="element-262">Email delivery</strong> — To send your product and
                communications.
              </li>
              <li data-id="element-263">
                <strong data-id="element-264">Analytics</strong> — To understand website usage and
                improve our offerings.
              </li>
            </ul>
            <p className="mt-4" data-id="element-265">
              These services have their own privacy policies and handle your
              data according to their terms.
            </p>
          </section>

          <section data-id="element-266">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-267">
              6. Data Security
            </h2>
            <p data-id="element-268">
              We take reasonable measures to protect your personal information
              from unauthorized access, alteration, or destruction. However, no
              method of transmission over the internet is 100% secure, and we
              cannot guarantee absolute security.
            </p>
          </section>

          <section data-id="element-269">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-270">
              7. Cookies
            </h2>
            <p data-id="element-271">
              Our website may use cookies and similar technologies to improve
              your browsing experience and analyze site traffic. You can control
              cookie settings through your browser preferences.
            </p>
          </section>

          <section data-id="element-272">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-273">
              8. Your Rights
            </h2>
            <p className="mb-4" data-id="element-274">You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2 text-[#3D3D3D]" data-id="element-275">
              <li data-id="element-276">Request access to the personal data we hold about you</li>
              <li data-id="element-277">Request correction or deletion of your personal data</li>
              <li data-id="element-278">Opt out of marketing communications</li>
              <li data-id="element-279">Request a copy of your data in a portable format</li>
            </ul>
          </section>

          <section data-id="element-280">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-281">
              9. Children's Privacy
            </h2>
            <p data-id="element-282">
              Our Product is not intended for individuals under the age of 18.
              We do not knowingly collect personal information from children.
            </p>
          </section>

          <section data-id="element-283">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-284">
              10. Changes to This Policy
            </h2>
            <p data-id="element-285">
              We may update this Privacy Policy from time to time. Changes will
              be posted on this page with an updated revision date. We encourage
              you to review this page periodically.
            </p>
          </section>

          <section data-id="element-286">
            <h2 className="text-xl lg:text-2xl font-serif font-bold text-[#1A1A1A] mb-4" data-id="element-287">
              11. Contact Us
            </h2>
            <p data-id="element-288">
              If you have questions about this Privacy Policy or your personal
              data, please contact us at{' '}
              <span className="text-[#1B6B3A] font-medium" data-id="element-289">
                support@closingnumberlock.com
              </span>
              .
            </p>
          </section>
        </div>

        <footer className="mt-24 lg:mt-32 pt-12 border-t border-[#1B6B3A]/20 pb-12" data-id="element-290">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-[#6B6B6B]" data-id="element-291">
            <p data-id="element-292">
              © {new Date().getFullYear()} Closing Number Lock. All rights
              reserved.
            </p>
            <div className="flex items-center gap-6" data-id="element-293">
              <Link to="/terms" className="hover:text-[#1B6B3A] transition-colors duration-200 underline underline-offset-2 decoration-[#6B6B6B]/30 hover:decoration-[#1B6B3A]" data-id="element-294">
                Terms of Service
              </Link>
              <span className="text-[#1A1A1A] font-medium" data-id="element-295">Privacy Policy</span>
            </div>
          </div>
        </footer>
      </div>
    </div>;
}